import { get } from '../../../api';

export const getTipos = async () => {
  const res = await get('/api/conectores/tipos/comando');

  return res.map((item) => ({
    key: item.tp,
    value: item.tp,
    title: item.ds,
  }));
};
